import React from "react";
import { useTranslation } from "react-i18next";

export interface DocumentStatusItem {
  type: string;
  language: string;
  status: "ready" | "generating";
}

interface DocumentStatusesProps {
  statuses: DocumentStatusItem[];
  stage?: string | null;
  hideWhenDone?: boolean;
}

export const DocumentStatuses: React.FC<DocumentStatusesProps> = ({
  statuses,
  stage,
  hideWhenDone = true,
}) => {
  const { t } = useTranslation(["common"]);
  if (!statuses.length) return null;
  if (hideWhenDone && stage === "done") return null;
  return (
    <div className="w-full text-left">
      <h2 className="mb-2 text-base font-semibold">
        {t("generation.documents", { defaultValue: "Documents" })}
      </h2>
      <ul className="overflow-hidden bg-white border divide-y rounded">
        {statuses.map((d, idx) => (
          <li
            key={`${d.type}-${d.language}-${idx}`}
            className="flex items-center justify-between px-3 py-2 text-sm"
          >
            <span className="text-foreground/90">
              {d.type}
              {d.language ? ` — ${d.language.toUpperCase()}` : ""}
            </span>
            <span
              className={
                d.status === "ready"
                  ? "text-green-800 bg-green-100 border border-green-200 rounded px-2 py-0.5 text-xs"
                  : "text-amber-800 bg-amber-100 border border-amber-200 rounded px-2 py-0.5 text-xs"
              }
            >
              {d.status === "ready"
                ? t("generation.ready", { defaultValue: "Ready" })
                : t("generation.generating", { defaultValue: "Generating" })}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DocumentStatuses;
